"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcAutocomplete2 = void 0;
var react_1 = __importStar(require("react"));
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var clsx_1 = __importDefault(require("clsx"));
var AcChip2_1 = require("./AcChip2");
var AcAutocomplete_module_scss_1 = __importDefault(require("./AcAutocomplete.module.scss"));
var AcFormFieldBadge_1 = require("../form/AcFormFieldBadge");
/**
 * An autocomplete input component. Selected items are shown as chips.
 * It will auto detect whether the input should be a string or an array based on the the initial value.
 */
var AcAutocomplete2 = function (_a) {
    var value = _a.value, required = _a.required, loading = _a.loading, _b = _a.itemsRenderLimit, itemsRenderLimit = _b === void 0 ? 0 : _b, followInput = _a.followInput, allowTextInput = _a.allowTextInput, placeholder = _a.placeholder, items = _a.items, getItemId = _a.getItemId, getItemValue = _a.getItemValue, getItemTooltip = _a.getItemTooltip, getItemTitle = _a.getItemTitle, getItemSubtitle = _a.getItemSubtitle, shouldItemRender = _a.shouldItemRender, isItemSelectable = _a.isItemSelectable, renderItem = _a.renderItem, renderMenu = _a.renderMenu, renderInput = _a.renderInput, onSelect = _a.onSelect, onChangeInputValue = _a.onChangeInputValue, onDeleteItem = _a.onDeleteItem, getItemChipTitle = _a.getItemChipTitle, getItemChipSubtitle = _a.getItemChipSubtitle, getItemChipTooltip = _a.getItemChipTooltip, onChangeValue = _a.onChangeValue, onBlurValue = _a.onBlurValue, invalid = _a.invalid, hideNoData = _a.hideNoData, noData = _a.noData;
    /**
     * To support showing dropdown menu under the input
     */
    var htmlInputDivElRef = react_1.useRef(null);
    var _c = __read(react_1.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read(react_1.useState(typeof value === 'string' ? value : ''), 2), inputValue = _d[0], setInputValue = _d[1];
    var _e = __read(react_1.useState(true), 2), showAllItems = _e[0], setShowAllItems = _e[1];
    var isSingleInput = !Array.isArray(value);
    react_1.useEffect(function () {
        if (itemsRenderLimit && (items === null || items === void 0 ? void 0 : items.length) > itemsRenderLimit) {
            setShowAllItems(false);
        }
        else {
            setShowAllItems(true);
        }
    }, [items]);
    react_1.useEffect(function () {
        if (typeof value === 'string') {
            setInputValue(value);
        }
    }, [value]);
    var onBlur = function () {
        onBlurValue === null || onBlurValue === void 0 ? void 0 : onBlurValue(value);
    };
    var getItemById = react_1.useCallback(function (_id) {
        if (!_id)
            return undefined;
        return items.find(function (i) { return getItemId(i) === _id; });
    }, [items]);
    var isItemSelected = function (item) {
        var _a, _b;
        var selectedId = getItemId(item);
        if (Array.isArray(value)) {
            if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                // @ts-ignore
                return (_b = (_a = value === null || value === void 0 ? void 0 : value.map) === null || _a === void 0 ? void 0 : _a.call(value, function (v) { return getItemId(v); })) === null || _b === void 0 ? void 0 : _b.includes(selectedId);
            }
        }
        else {
            return value === selectedId;
        }
        return false;
    };
    var getSelectedItems = function () {
        var selectedItems = [];
        if (Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
            value.forEach(function (v) {
                var id = getItemId(v);
                var selectedItem = getItemById(id);
                if (selectedItem) {
                    selectedItems.push(selectedItem);
                }
            });
        }
        else {
            var selectedItem = getItemById(getItemId(value));
            if (selectedItem) {
                selectedItems.push(selectedItem);
            }
        }
        return selectedItems;
    };
    var onDeleteChip = function (deletedItem) {
        var newValue;
        if (Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
            // @ts-ignore
            newValue = value.filter(function (v) {
                return getItemId(v) !== getItemId(deletedItem);
            });
        }
        else if (getItemId(value) === getItemId(deletedItem)) {
            newValue = '';
        }
        else {
            newValue = "" + value;
        }
        onDeleteItem === null || onDeleteItem === void 0 ? void 0 : onDeleteItem(deletedItem);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(newValue);
    };
    var defaultRenderInput = function (propsIEL) {
        var selectedItems = getSelectedItems();
        var showInput = true;
        if (isSingleInput && (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0) {
            showInput = false;
        }
        return (react_1.default.createElement("div", { ref: htmlInputDivElRef, className: clsx_1.default('d-flex align-items-center border  bg-white  position-relative min-width-0 pr-2', { 'rounded-top-sm': isOpen }, { 'rounded-sm': !isOpen }, { 'border-secondary': !invalid }, { 'border-danger': invalid }) },
            react_1.default.createElement("div", { className: clsx_1.default('d-flex flex-wrap align-items-center overflow-auto flex-grow-1') },
                selectedItems.map(function (selectedItem, i) {
                    return (react_1.default.createElement(AcChip2_1.AcChip2, { key: "" + i, item: selectedItem, title: (getItemChipTitle === null || getItemChipTitle === void 0 ? void 0 : getItemChipTitle(selectedItem)) ||
                            (getItemTitle === null || getItemTitle === void 0 ? void 0 : getItemTitle(selectedItem)) ||
                            (getItemValue === null || getItemValue === void 0 ? void 0 : getItemValue(selectedItem)), subtitle: getItemChipSubtitle === null || getItemChipSubtitle === void 0 ? void 0 : getItemChipSubtitle(selectedItem), tooltip: getItemChipTooltip === null || getItemChipTooltip === void 0 ? void 0 : getItemChipTooltip(selectedItem), onDelete: function (deletedItem) { return onDeleteChip(deletedItem); }, titleMaxWidth: required ? 220 : undefined }));
                }),
                showInput && (react_1.default.createElement("input", __assign({ className: "form-control border-0 d-flex flex-grow-1 w-auto shadow-none" }, propsIEL, { placeholder: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 ? undefined : placeholder })))),
            required && (react_1.default.createElement("div", { style: { width: 50, flex: '0 0 14px' } },
                react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center h-100" },
                    react_1.default.createElement(AcFormFieldBadge_1.AcFormFieldBadge, { type: "required" }))))));
    };
    var defaultOnSelect = function (selectedValue, item) {
        if (!isSingleInput) {
            if (!isItemSelected(item)) {
                var existingValues = value;
                onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(__spreadArray(__spreadArray([], __read(existingValues)), [item]), item);
            }
            // } else if (getItemValue) {
            //   onChangeValue?.(getItemValue(item), item);
        }
        else {
            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(item, item);
        }
        setInputValue('');
    };
    var defaultShouldItemRender = function (item, _value) {
        var shouldRender = true;
        if (shouldItemRender && typeof _value === 'string' && _value.trim() !== '') {
            shouldRender = shouldItemRender(item, _value);
        }
        return shouldRender && !isItemSelected(item);
    };
    var defaultRenderItemComponent = function (key, title, subtitle, tooltip, isHighlighted) {
        return (react_1.default.createElement("div", { key: key, title: tooltip, className: "d-flex flex-row border min-width-0 " + (isHighlighted ? 'bg-apzlightblue border-line' : 'bg-white border-white') + " px-2 py-1", style: {
                cursor: 'default',
                // @ts-ignore
                // width: inputRef?.current?.offsetWidth - 2,  // keep the dropdown items same width as form field, the -2 takes into account menu padding
            } },
            react_1.default.createElement("div", { className: "text-truncate text-dark flex-shrink-1 fs-14 min-width-0", style: {} }, title),
            subtitle && (react_1.default.createElement("div", { className: "fs-11 text-truncate flex-shrink-1 ml-auto min-width-0", style: {} }, subtitle))));
    };
    var defaultRenderItem = function (item, isHighlighted, styles) {
        var dataId = getItemId(item);
        var dataValue = (getItemTitle === null || getItemTitle === void 0 ? void 0 : getItemTitle(item)) || (getItemValue === null || getItemValue === void 0 ? void 0 : getItemValue(item)) || "" + item;
        var dataSubtitle = getItemSubtitle === null || getItemSubtitle === void 0 ? void 0 : getItemSubtitle(item);
        var key = "AcAutocomplete2:" + dataId;
        var tooltip = dataValue ? (getItemTooltip === null || getItemTooltip === void 0 ? void 0 : getItemTooltip(item)) || (getItemChipTooltip === null || getItemChipTooltip === void 0 ? void 0 : getItemChipTooltip(item)) : undefined;
        return defaultRenderItemComponent(key, dataValue, dataSubtitle, tooltip, isHighlighted);
    };
    var defaultRenderMenu = function (menuItems, menuValue, styles) {
        var _a;
        var menuStyle = __assign(__assign({}, styles), { left: 0, width: '100%', top: 54 });
        var inputEls = (_a = htmlInputDivElRef === null || htmlInputDivElRef === void 0 ? void 0 : htmlInputDivElRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input');
        var inputEl = inputEls === null || inputEls === void 0 ? void 0 : inputEls.item(0);
        if (inputEl) {
            menuStyle.top = inputEl.offsetTop + inputEl.offsetHeight + 9; // puts right under input field
            if (followInput) {
                menuStyle.left = inputEl.offsetLeft;
                menuStyle.width = inputEl.width + "px";
            }
        }
        if (loading) {
            return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign({}, menuStyle) },
                react_1.default.createElement("div", { className: "px-2 py-1" },
                    react_1.default.createElement("i", { className: "fas fa-spinner fa-spin fs-12 text-cloudLink", role: "status" }))));
        }
        if (!menuItems || (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) === 0) {
            // fixes issue when dropdown is shown but thin when no items
            // menuStyle.display = 'none';
            if (value !== '' && !hideNoData) {
                var noDataContent = react_1.default.createElement("div", { className: "px-2 py-1" }, "\u691C\u7D22\u7D50\u679C\u306F\u3042\u308A\u307E\u305B\u3093");
                if (typeof noData === 'string') {
                    noDataContent = react_1.default.createElement("div", { className: "px-2 py-1" }, noData);
                }
                else if (noData) {
                    noDataContent = noData;
                }
                return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign({}, menuStyle) }, noDataContent));
            }
            // fixes issue when dropdown is shown but thin when no items
            menuStyle.display = 'none';
            return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign({}, menuStyle) }, "DISPLAY NOTHING"));
        }
        return (react_1.default.createElement("div", { className: AcAutocomplete_module_scss_1.default.dropdown, style: __assign({}, menuStyle) },
            showAllItems ? menuItems : menuItems.slice(0, itemsRenderLimit),
            !showAllItems &&
                defaultRenderItemComponent('more', react_1.default.createElement("a", { href: "#", onClick: function (event) {
                        event.preventDefault();
                        setShowAllItems(true);
                        return false;
                    } }, "\u4ED6 " + ((menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) - itemsRenderLimit) + " \u4EF6\u306E\u5019\u88DC"))));
    };
    var defaultOnChange = function (e, iValue) {
        setInputValue(iValue);
        onChangeInputValue === null || onChangeInputValue === void 0 ? void 0 : onChangeInputValue(e, iValue);
        if (allowTextInput) {
            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(iValue);
        }
    };
    var defaultGetItemValue = function (item) {
        return "" + item;
    };
    return (react_1.default.createElement(react_autocomplete_1.default, { value: inputValue, items: items, getItemValue: getItemValue || defaultGetItemValue, shouldItemRender: defaultShouldItemRender, isItemSelectable: isItemSelectable, renderItem: renderItem || defaultRenderItem, renderMenu: renderMenu || defaultRenderMenu, renderInput: renderInput || defaultRenderInput, onSelect: onSelect || defaultOnSelect, onChange: defaultOnChange, onMenuVisibilityChange: function (isMenuVisible) { return setIsOpen(isMenuVisible); }, inputProps: {
            placeholder: placeholder,
            onBlur: onBlur,
        }, wrapperStyle: {
            display: 'block',
            position: 'relative',
            // flex: '1 1 100%',
            // maxWidth: '100%',
        } }));
};
exports.AcAutocomplete2 = AcAutocomplete2;
exports.AcAutocomplete2.displayName = 'AcAutocomplete2';
//# sourceMappingURL=AcAutocomplete2.js.map